// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.incoming-request-modal .modal-dialog {
  width: 809px;
  max-width: 809px;
}

.incoming-request-modal .modal-body {
  padding: 1.5rem 2rem;
}

.incoming-request-modal .modal-body .d-flex.justify-content-between {
  gap: 1rem;
}

.incoming-request-modal .modal-body .d-flex.justify-content-between > div {
  flex: 1 1;
}

.incoming-request-modal .modal-body > div {
  margin-bottom: 1rem;
}

.incoming-request-modal .modal-body > div:last-of-type {
  margin-bottom: 0;
}

.incoming-request-modal .modal-body .alert {
  margin-bottom: 1rem;
}

.incoming-request-modal .modal-body .alert + div {
  margin-top: 0;
}



`, "",{"version":3,"sources":["webpack://./src/Pages/HGO/Dashboard/CommonComponents/IncomingRequest.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf","sourcesContent":[".incoming-request-modal .modal-dialog {\n  width: 809px;\n  max-width: 809px;\n}\n\n.incoming-request-modal .modal-body {\n  padding: 1.5rem 2rem;\n}\n\n.incoming-request-modal .modal-body .d-flex.justify-content-between {\n  gap: 1rem;\n}\n\n.incoming-request-modal .modal-body .d-flex.justify-content-between > div {\n  flex: 1;\n}\n\n.incoming-request-modal .modal-body > div {\n  margin-bottom: 1rem;\n}\n\n.incoming-request-modal .modal-body > div:last-of-type {\n  margin-bottom: 0;\n}\n\n.incoming-request-modal .modal-body .alert {\n  margin-bottom: 1rem;\n}\n\n.incoming-request-modal .modal-body .alert + div {\n  margin-top: 0;\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
